import React from "react";
import PropTypes from "prop-types";
import withCustomComponent from "providers/withCustomComponent";
import DocumentsContainer from "features/document/edit/documents/components/DocumentsContainer";
import { useSelector, shallowEqual } from "react-redux";
import { GET_FOLDER_HEADER_QUERY } from "features/folder/edit/generalData/info/queries";
import { useQueryWithErrorHandling } from "customHooks/errorHandling";
import { getInt } from "utils/functions";

const FolderDocumentsContainer = ({ documentId, siteId, history, onChangeActiveStep }) => {
  const onDocumentsHistoryClick = fileId => {
    onChangeActiveStep(-1);
    history.push(`/folders/${documentId}/${siteId}/documentHistory/${fileId}`);
  };

  const { folderNumber } = useSelector(state => state.currentFolder.header, shallowEqual);
  const { data } = useQueryWithErrorHandling(GET_FOLDER_HEADER_QUERY, {
    variables: { documentId: getInt(documentId), siteId: getInt(siteId) },
    skip: !documentId
  });

  return (
    <DocumentsContainer
      documentId={documentId}
      siteId={siteId}
      documentNumber={folderNumber}
      onDocumentsHistoryClick={onDocumentsHistoryClick}
      clientDefaultEmail={data?.folderHeader?.client?.defaultEmail}
    />
  );
};

FolderDocumentsContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  onChangeActiveStep: PropTypes.func.isRequired
};

export default withCustomComponent("FolderDocumentsContainer")(FolderDocumentsContainer);
